var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14583 8.82425C8.0491 8.83658 7.95122 8.83658 7.85449 8.82425C7.70044 8.80461 7.52843 8.73083 7.26063 8.51577C6.98495 8.29437 6.65959 7.96717 6.18683 7.49017L5.02196 6.31486C4.82757 6.11873 4.51099 6.11731 4.31486 6.3117C4.11873 6.50609 4.11731 6.82267 4.3117 7.0188L5.49756 8.21529C5.94419 8.66594 6.30922 9.03425 6.63447 9.29546C6.97269 9.56708 7.31598 9.7637 7.72806 9.81622C7.90874 9.83925 8.09159 9.83925 8.27227 9.81622C8.68435 9.7637 9.02764 9.56708 9.36586 9.29546C9.69111 9.03425 10.0561 8.66594 10.5028 8.21529L11.6886 7.0188C11.883 6.82267 11.8816 6.50609 11.6855 6.3117C11.4893 6.11731 11.1728 6.11873 10.9784 6.31486L9.8135 7.49017C9.34074 7.96717 9.01538 8.29437 8.73969 8.51577C8.4719 8.73083 8.29988 8.80461 8.14583 8.82425Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.758341780d79bd77d58e0c8e8bf3775e.svg";
export { ForwardRef as ReactComponent };